module.exports = __webpack_public_path__ + "static/media/mc.a6ed56ab.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mc.svg
// module id = 879
// module chunks = 0